"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
const StyledRule = styled_1.default.hr `
	border: none;
	border-bottom: 1px solid ${theme_1.default.colours.delimiter.default};
	margin: ${theme_1.default.spacing.large} -${theme_1.default.spacing.large};
`;
exports.Rule = StyledRule;
//# sourceMappingURL=Rule.js.map